import React from 'react';

function GoogleIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="#4285F4"
        d="M23.5 12.3c0-.9-.1-1.5-.2-2.2H12v4.2h6.6c-.1 1.1-.9 2.8-2.5 3.9l-.1.1 3.6 2.8.3.1c2.3-2.1 3.6-5.2 3.6-8.9Z"
      />
      <path
        fill="#34A853"
        d="M12 23.5c3.3 0 6-1.1 8-2.9l-3.8-3c-1 .7-2.4 1.2-4.2 1.2a6.6 6.6 0 0 1-6.2-4.5l-.1.1-3.7 2.9v.1A12 12 0 0 0 12 23.5Z"
      />
      <path fill="#FBBC05" d="M5.8 14.3A6.6 6.6 0 0 1 5.8 9.7l-3.9-3A12 12 0 0 0 0 12c0 1.9.5 3.7 1.3 5.3l4.5-3Z" />
      <path
        fill="#EA4335"
        d="M12 4.7c2.3 0 3.9 1 4.8 1.9l3.5-3.4A12 12 0 0 0 12 0 12 12 0 0 0 1.3 6.7l4.5 3.5A6.6 6.6 0 0 1 12 4.7Z"
      />
    </svg>
  );
}

export default GoogleIcon;
